export class AppModeService {
    public static get isDevelopmentMode() {
        return location.port === '4200';
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/services/app.mode.service.ts